import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'
import Index from '../components/Index.vue'
import Orders from '../components/orders/Orders.vue'
import Clients from '../components/clients/Clients.vue'
import ClientDiscLoad from '../components/clients/ClientDiscLoad.vue'
import Products from '../components/products/Products.vue'
import Users from '../components/users/Users.vue'
import UserEditor from '../components/users/UserEditor.vue'
import ProductEditor from '../components/products/ProductEditor.vue'
import Forbidden from '../components/Forbidden.vue'
import ProductsLoad from '../components/products/ProductsLoad.vue'
import ProductsLoadStock from '../components/products/ProductsLoadStock.vue'
import ability from '../util/abilities';
import store from '../store'
import {USER_REQUEST} from "../store/actions/user";
import * as routes from './routes';


Vue.use(Router);

const canNavigate = (to) => {
    return to.matched.some(route => {
        return ability.can('manage', route.name)
    }) || to.path === routes.FORBIDDEN.route;
};

export default {
    router: new Router({
        mode: 'history',
        routes: [
            {
                path: routes.DASHBOARD.route,
                name: routes.DASHBOARD.name,
                component: Index,
            },
            {
                path: routes.LOGIN.route,
                name: routes.LOGIN.name,
                component: Login,
                meta: {
                    excludeAuth: true,
                    layout: 'anon'
                }
            },
            {
                path: routes.ORDERS.route,
                name: routes.ORDERS.name,
                component: Orders,
            },
            {
                path: routes.CLIENTS.route,
                name: routes.CLIENTS.name,
                component: Clients,
            },
            {
                path: routes.PRODUCTS.route,
                name: routes.PRODUCTS.name,
                component: Products,
            },
            {
                path: routes.PRODUCTS_LOAD.route,
                name: routes.PRODUCTS_LOAD.name,
                component: ProductsLoad,
            },
            {
                path: routes.PRODUCTS_LOAD_STOCK.route,
                name: routes.PRODUCTS_LOAD_STOCK.name,
                component: ProductsLoadStock,
            },
            {
                path: routes.PRODUCT_CREATOR.route,
                name: routes.PRODUCT_CREATOR.name,
                component: ProductEditor,
            },
            {
                path: routes.PRODUCT_EDITOR.route,
                name: routes.PRODUCT_EDITOR.name,
                component: ProductEditor,
                props: (route) => {
                    const productIdIn = route.params.productId;
                    return {productIdIn}
                },
            },
            {
                path: routes.USERS.route,
                name: routes.USERS.name,
                component: Users,
            },
            {
                path: routes.USER_CREATOR.route,
                name: routes.USER_CREATOR.name,
                component: UserEditor,
            },
            {
                path: routes.USER_EDITOR.route,
                name: routes.USER_EDITOR.name,
                component: UserEditor,
                props: (route) => {
                    const userIdIn = route.params.userId;
                    return {userIdIn: Number(userIdIn)}
                },
            },
            {
                path: routes.FORBIDDEN.route,
                component: Forbidden,
            },
            {
                path: routes.CLIENTS_LOAD_DISC.route,
                name: routes.CLIENTS_LOAD_DISC.name,
                component: ClientDiscLoad,
            },
            {
                path: routes.INDEX.route,
                name: routes.INDEX.name,
                component: Index,
            },
            {
                path: '*',
                component: Index,
            },
        ]
    }),
    init() {
        this.router.beforeEach((to, from, next) => {
            if (to.meta.excludeAuth) {
                if (!store.getters.isAuthenticated)
                    next();
                else
                    next(routes.DASHBOARD.route)

            } else {
                if (store.getters.isAuthenticated) {
                    if (!store.getters.isUserLoaded) {
                        store.dispatch(USER_REQUEST).then(() => {
                            if (canNavigate(to))
                                next();
                            else
                                return next(routes.FORBIDDEN.route)
                        });
                    } else {
                        if (canNavigate(to))
                            next();
                        else
                            next(routes.FORBIDDEN.route)
                    }
                } else {
                    next(routes.LOGIN.route)
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/router/index.js